module.exports = __webpack_public_path__ + "static/media/signed.e5c7c3a7.svg";